module.exports = __webpack_public_path__ + "img/eCPPT-badge.7afec493.png";